export default $client => ({
    get: () => $client.get('feedback')
})
